/*
 reset-password component
 url match: /reset-password
*/
import { withRouter, Link } from 'react-router-dom';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { loginStyles } from '../../Styles/loginStyles';
import FormControl from '@material-ui/core/FormControl';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Loader from 'react-loader-spinner'
import InputAdornment from '@material-ui/core/InputAdornment';
import BackgroundImage from '../../Common/BackgroundImage';

@inject('userStore')
@observer
class ResetPassword extends Component {

    state = {
        password1: "",
        password2: "",
        validationErrors: {},
        token: "",
        showPassword1: false,
        showPassword2: false,
        type: ''
    }

    handleChange = (field, value) => {
        this.setState({
            [field]: value
        });
    }

    componentDidMount() {
        this.setState({
            token: this.props.match.params['token'],
            type: this.props.match.params['type']
        })
    }

    resetPassword = (e) => {
        e.preventDefault();
        const { password1, password2, validationErrors, type } = this.state;
        let passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        let inValid = /\s/;
        /*if (!isObjectEmpty(validationErrors)) {
            this.setState({ errorMessage: "Please correct the above errors before proceeding." });
            return;
        }*/
        if (inValid.test(password1) || inValid.test(password2)) {
            this.setState({ errorMessage: "Password should not contain spaces." });
            return;
        }
        if (!password1 || !password2) {
            this.setState({ errorMessage: "Please enter new password before proceeding." });
            return;
        }
        if (!(password1 == password2)) {
            this.setState({ errorMessage: "Passwords do not match." });
            return;
        }
        if (!(password1.length >= 6)) {
            this.setState({ errorMessage: "Password should contain at least 6 characters." });
            return;
        }
        this.setState({ errorMessage: undefined });
        console.log(this.state.type, this.state.type.toLowerCase() == 'resetPassword')
        if (this.state.type.toLowerCase() == 'resetpassword')
            this.props.userStore.resetPassword(this.state.token, password1)
        else
            this.props.userStore.updateEmailResetPassword(this.state.token, password1)
    }

    render() {
        const { inProgress, pwdTokenVerified, statusText } = this.props.userStore;
        const { classes } = this.props;
        const { password1, password2, validationErrors, showPassword1, showPassword2 } = this.state;

        return (

            !pwdTokenVerified ?
                <div className={classes.rowFlex}>
                    <div className="loginContainer" style={{ width: '100%' }}>
                        <Link to="/">
                            <ReactSVG
                                beforeInjection={svg => {
                                    svg.classList.add(classes.svg)
                                }}
                                src={Images.bigLogo} />
                        </Link>
                        <p className={classes.pageHeading}>Set your password?</p>
                        <form style={{ marginTop: '3 vh' }} noValidate autoComplete="off" className={classes.formStyle}>
                            <FormControl error aria-describedby="component-error-text" className={classes.formControl}>
                                <TextField required id="password1" placeholder="New password"
                                    type={showPassword1 ? 'text' : 'password'} name="password1"
                                    margin="normal" variant="filled" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                        classes: {
                                            input: classes.textFieldInput,
                                        },
                                        endAdornment: <InputAdornment position="end" >
                                            {!showPassword1 ? <ReactSVG src={Images.visibilityIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword1: true })} /> :
                                                <ReactSVG src={Images.visibilityOffIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword1: false })} />}
                                        </InputAdornment>

                                    }}
                                    value={password1}
                                    onChange={((event) => this.handleChange("password1", event.target.value))}
                                />
                                <TextField required id="password2" placeholder="Confirm new password"
                                    type={showPassword2 ? 'text' : 'password'} name="password"
                                    margin="normal" variant="filled" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                        classes: {
                                            input: classes.textFieldInput,
                                        },
                                        endAdornment: <InputAdornment position="end" >
                                            {!showPassword2 ? <ReactSVG src={Images.visibilityIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword2: true })} /> :
                                                <ReactSVG src={Images.visibilityOffIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword2: false })} />}
                                        </InputAdornment>

                                    }}
                                    value={password2}
                                    onChange={(event) => this.handleChange("password2", event.target.value)}
                                />
                            </FormControl>
                            {this.state.errorMessage && <p className={classes.errorStyle}>{this.state.errorMessage}</p>}

                            {
                                inProgress ? <Button variant="contained" className={classes.button} fullWidth>
                                    <Loader height={30} width={30} color={this.props.theme.palette.white} />
                                </Button> :
                                    <Button variant="contained" className={classes.button} type="submit" onClick={this.resetPassword} fullWidth>
                                        Reset password
                      </Button>
                            }
                        </form>
                    </div>
                </div> : [
                    (!inProgress && pwdTokenVerified) ?
                        <div className={classes.rowFlex} style={{overflowY: 'hidden'}}>
                            <div style={{ width: '50%' }}>
                                <BackgroundImage/>
                            </div>
                            <div className="loginContainer">
                                <Link to="/">
                                    <ReactSVG
                                        beforeInjection={svg => {
                                            svg.classList.add(classes.svg)
                                        }}
                                        src={Images.logo} />
                                </Link>
                                <p style={{ color: this.props.theme.palette.white }}>Password reset successfully.&nbsp;
                        <Link to="/">Click here </Link> to login.
                </p>
                            </div> </div> : <div className={classes.rowFlex} style={{overflowY: 'hidden'}}>
                            <div style={{ width: '50%' }}>
                               <BackgroundImage/>
                            </div><div className="loginContainer">
                                <Link to="/">
                                    <ReactSVG
                                        beforeInjection={svg => {
                                            svg.classList.add(classes.svg)
                                        }}
                                        src={Images.logo} />
                                </Link>
                                <p>Password reset token expired!</p>
                            </div>
                        </div>
                ]

        );
    }
}
export default withStyles(loginStyles, { withTheme: true })(withRouter(ResetPassword));
